import React, { FC, useState } from 'react';
import Select from 'react-select';
import sortBy from 'lodash.sortby';
import moment from 'moment-timezone';

interface TimeZoneProps {
  label: string;
  value: string;
  time: string;
  offset: number;
}

interface Props {
  onChange: (option: any) => void;
  value: string;
  isClearable: boolean;
}

const formatTimezone = (tzString: string) =>
  `(GMT${moment.tz(tzString).format('Z')}) ${tzString}`;

const getTimezoneProps = (tzString: string): TimeZoneProps => {
  const tz = moment.tz(tzString);
  const tzStringOffset = parseInt(
    tz
      .format('Z')
      .replace(':00', '')
      .replace(':30', '.5')
  );

  return {
    label: formatTimezone(tzString),
    value: `${tzString}`,
    time: tzStringOffset === 0 ? '0' : tzStringOffset.toFixed(2),
    offset: tz['_offset'],
  };
};

const timeZones: TimeZoneProps[] = sortBy(
  moment.tz.names().map(tz => getTimezoneProps(tz)),
  [el => -el.time]
);

const TimeZoneSelect: FC<Props> = props => {
  const { onChange, value, isClearable = false, ...restProps } = props;

  const [selectedValue, setSelectedValue] = useState(value);
  const selected = timeZones.find(({ value }) => value === selectedValue);

  return (
    <Select
      isClearable={isClearable}
      options={timeZones}
      isMulti={false}
      onChange={option => {
        setSelectedValue(option.value);
        onChange && onChange(option.value);
      }}
      value={selected}
      {...restProps}
    />
  );
};

export default TimeZoneSelect;
